module.exports = __webpack_public_path__ + "static/media/users-class.334b1f9a.svg";